<div class="card" [attr.data-testid]="'sub-criteria-x-card-' + tab().id">
  @if (subCriteriaLoading()) {
    <app-loading />
  } @else {
    <app-badge-list
      [items]="badgeListItems()"
      [headerInputTemplate]="showsInclusionSelection() ? inclusionTemplate : null"
      [isOpenable]="false"
      [attr.data-testid]="'sub-criteria-x-table-' + tab().id"
    >
      <ng-template #inclusionTemplate let-item>
        <app-model-field-select-inclusion
          [id]="'sub-criteria-x-select-' + item.key"
          [value]="item.originalItem.selectedValue"
          [isReadOnly]="disabled()"
          (valueChange)="onInclusionChange(item.key, $event)"
        />
      </ng-template>
    </app-badge-list>

    @if (showsAllExcludedMessage()) {
      <div class="mt-3">
        <p-message severity="error">
          {{ 'project.steps.evaluationSubCriteria.allExcludedError' | transloco }}
        </p-message>
      </div>
    }

    @if (showsSaveButton()) {
      <div class="flex justify-end mt-3" [attr.data-testid]="'sub-criteria-x-save-' + tab().id">
        <app-project-step-save-button
          [loading]="saving()"
          [disabled]="saving()"
          (clicked)="onInclusionsSave()"
        ></app-project-step-save-button>
      </div>
    }
  }
</div>

@if (showsWeightingBlock()) {
  <app-criteria-weighting-x
    class="block mt-5"
    translationKeyPrefix="project.steps.evaluationSubCriteria"
    identifierPrefix="SC"
    [testId]="'sub-criteria-x-weighting-' + tab().id"
    [items]="pairwiseItems()"
    [comparisons]="comparisons()"
    [weighting]="weighting()"
    [auditInfo]="auditInfo()"
    [disabled]="disabled()"
    [saving]="saving()"
    (comparisonsSave)="onComparisonsSave($event)"
    (weightingSave)="onWeightingSave($event)"
  ></app-criteria-weighting-x>
}
